import { SaiposTableConfiguration } from "@/core/SaiposTableConfiguration";
import { useEffect, useRef, useState } from "react";
import { useAppConfiguration } from "./useAppConfiguration";
import { EcleticaTableConfiguration } from "@/core/EcleticaTableConfiguration";
import { NetLogicTableConfiguration } from "@/core/NetLogicTableConfiguration";
import { ColibriTableConfiguration } from "@/core/ColibriTableConfiguration";
import { TableServices } from "@/core/Enum";

const configAdapters = {
  [TableServices.ECLETICA]: EcleticaTableConfiguration,
  [TableServices.SAIPOS]: SaiposTableConfiguration,
  [TableServices.NETLOGIC]: NetLogicTableConfiguration,
  [TableServices.COLIBRI]: ColibriTableConfiguration,
};

const getConfigAdapter = (tableService) => {
  return configAdapters[tableService]
    ? configAdapters[tableService].fromStorage()
    : null;
};

export function useTableConfiguration() {
  const [appConfigurations] = useAppConfiguration();
  const [tableConfigurations, setTableConfigurations] = useState(null);
  const adapterRef = useRef(null);

  const tableService = appConfigurations?.tableService;

  useEffect(() => {
    if (!tableService) return;

    const loadConfig = () => {
      adapterRef.current?.removeListener();

      const adapter = getConfigAdapter(tableService);
      if (!adapter) return;

      adapter.addListener(loadConfig);
      adapterRef.current = adapter;
      setTableConfigurations(adapter);
    };

    loadConfig();

    return () => adapterRef.current?.removeListener();
  }, [tableService]);

  const externalId = tableConfigurations?.externalId ?? null;
  const isValid = tableConfigurations?.isConfigured() ?? false;

  return [externalId, isValid];
}
